import EventEmitter from 'events'

import storage from 'amkit3-modules/utils/storage'
import cookie from 'amkit3-modules/utils/cookie'
import platformInfo from 'amkit3-modules/utils/platform-info'
import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'
import DanmuEvent from 'amkit3-modules/v/danmu/danmu-event'
import UIEvent from 'amkit3-modules/v/ui/ui-event'

import StatisticEvent from './statistic-event'

class StatisticCollector extends EventEmitter {
  constructor (player) {
    super()

    this.player = player
    this.errorURLMap = {}
    this.page_id = Math.random()

    setTimeout(() => {
      this.emit(StatisticEvent.PLAYER_LOAD)
    }, 0)

    this.player.once(PlaybackEvent.PLAYING, () => this.emit(StatisticEvent.PLAYER_PLAY))
    this.player.on(PlaybackEvent.PLAYING, () => this.emit(StatisticEvent.PLAYER_PLAYING))
    this.player.on(PlaybackEvent.ENDED, () => this.emit(StatisticEvent.PLAYER_ENDED))
    this.player.on(PlaybackEvent.BUFFERING, () => this.emit(StatisticEvent.PLAYER_BUFFERING))
    this.player.on(PlaybackEvent.NOT_BUFFERING, () => this.emit(StatisticEvent.PLAYER_NOT_BUFFERING))

    this.player.on(PlaybackEvent.START_PROGRESS, () => this.emit(StatisticEvent.PLAYBACK_PROGRESS))
    this.player.once(PlaybackEvent.START_PROGRESS, () => this.emit(StatisticEvent.PLAYBACK_VV))
    this.player.on(PlaybackEvent.ERROR, () => {
      let cdnURL = this.player.getCDNURL()
      if (cdnURL && !this.errorURLMap[cdnURL]) {
        this.emit(StatisticEvent.PLAYBACK_PROGRESS_ERROR)
        this.errorURLMap[cdnURL] = true
      }
    })
    this.player.once(PlaybackEvent.ERROR, () => this.emit(StatisticEvent.PLAYBACK_VV_ERROR))
    this.player.on(PlaybackEvent.TIME_UPDATE, () => this.emit(StatisticEvent.TIME_UPDATE))

    this.player.on(PlaybackEvent.BUFFERING, () => {
      if (this.bufferingTId) return
      this.bufferingTId = setTimeout(() => this.emit(StatisticEvent.PLAYBACK_LAGGING), 3000)
    })
    this.player.on(PlaybackEvent.NOT_BUFFERING, () => {
      clearTimeout(this.bufferingTId)
      this.bufferingTId = 0
    })

    
    this.player.on(UIEvent.VOLUME_CHANGE, () => this.emit(StatisticEvent.PLAYER_VOLUME_CHANGE))
    this.player.on(UIEvent.TIME_CHANGE, () => this.emit(StatisticEvent.PLAYER_SEEK_CHANGE))
    this.player.on(UIEvent.REPLAY_BUTTON_CLICK, () => {
      this.player.once(PlaybackEvent.PLAYING, () => this.emit(StatisticEvent.PLAYER_PLAY))
      this.emit(StatisticEvent.PLAYER_REPLAY)
    })
    
    this.player.on(DanmuEvent.DISABLE, () => this.emit(StatisticEvent.DANMU_DISABLE))
    this.player.on(DanmuEvent.SUBMIT, () => this.emit(StatisticEvent.DANMU_SUBMIT))
    this.player.on(DanmuEvent.TYPE_CHANGE, (props) => this.emit(StatisticEvent.DANMU_TYPE_CHANGE, props))
  }
  getVid () {
    return this.player.getVid()
  }
  getChannelId () {
    return this.player.getChannelId()
  }
  getLaiyuanv3 () {
    return this.player.getLaiyuanv3()
  }
  getVname () {
    return this.player.getVname()
  }
  getCurrentTime () {
    return this.player.getCurrentTime()
  }
  getSessionId () {
    if (global.ya) return global.YA.session_id.get()

    return storage.cookie('amkit3-v-player-session-id', Math.random(), {
      path: '/'
    })
  }
  getMId () {
    if (global.ya) return global.YA.mid.get()

    return storage.cookie('amkit3-v-player-machine-id', Math.random(), {
      path: '/',
      expires: new Date(new Date().valueOf() + 7 * 24 * 60 * 60 * 1000)
    })
  }
  getYYUId () {
    return cookie.get('yyuid') || '<no_yyuid>'
  }
  getPas () {
    return cookie.get('username') || '<no_username>'
  }
  getOS () {
    return platformInfo.getOS() || '<no_os>'
  }
  getSre () {
    return platformInfo.getSre() || '<no_sre>'
  }
  getUserAgent () {
    return global.navigator.userAgent
  }
  getPageId () {
    return this.page_id
  }

  getVolume () {
    return this.player.getVolume()
  }

  getPlayerState () {
    const state = this.player.getPlayerState()
    // console.log('getPlayerState:', state)
    switch (state) {
      case 'buffering': return 1;
      case 'playing': return 2;
      case 'pause': return 3;
      case 'error': return 4;
      case 'ended': return 5;
      default:
        return 0
    }
  }

  // CDN
  getCDN () {
    return this.player.getCDN()
  }
  getCDNURL () {
    return this.player.getCDNURL()
  }
  getCDNError () {
    return this.player.getCDNError()
  }
  getPlayerStatus () {
    return this.player.getCDNError()
  }

  // Browser
  getHref () {
    let href = window.location.href
    if (!href) href = '<no_href>'
    if (!isNaN(href)) href = 'str_' + href
    return href
  }
  getReferrer () {
    let referrer = document.referrer
    if (!referrer) referrer = '<no_referrer>'
    if (!isNaN(referrer)) referrer = 'str_' + referrer
    return referrer
  }
}

export default StatisticCollector
